<template>
  <div class="container menus">
    <van-cell-group class="menus__list">
      <van-cell style="display:flex;align-items:center;justify-content:center;" title="头像" size="large" is-link
        @click="linkComponents">
        <template #default>
          <van-image @click="fileClick" round width="1.5rem" height="1.5rem" :src="imgUrl" />
        </template>
      </van-cell>
      <van-cell @click="show=true;UserNewName=UserName" title="昵称" size="large" :value="UserName" is-link />

    </van-cell-group>
    <van-popup :close-on-click-overlay='false' :closeable='true' round v-model="show" position="bottom"
      :style="{ height: '30%' }">
      <van-field :clearable='true' label="昵称" input-align="right" v-model="UserNewName" placeholder="请输入昵称"
        @blur='ChangeName' />
    </van-popup>
    <input id="upload_file" type="file" style="display: none;" accept='image/*' name="file"
      @change="fileChange($event)" />
  </div>
</template>

<script>
import { CellGroup, Image, Popup, Field, Dialog } from 'vant'
import { getLocalStorage } from '@/utils/auth'
export default {
  name: 'SettingSelf',
  components: {
    [Dialog.name]: Dialog,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Field.name]: Field,
    [Popup.name]: Popup,

  },
  data () {
    return {
      UserName: '',
      show: false,
      imgUrl: '',
      UserNewName: ''
    }
  },

  mounted () {
    this.UserName = getLocalStorage('WX_User_Name')
    this.imgUrl = getLocalStorage('WX_User_Avatar')

  },
  destroyed () {  // 销毁时取消监听
  },
  methods: {
    // 修改名字
    ChangeName () {
      if (this.UserNewName != this.UserName && this.UserNewName != '') {
        Dialog.confirm({
          title: '是否确定修改昵称为',
          message: this.UserNewName
        }).then(() => {
          // on confirm
          this.UserName = this.UserNewName
          this.show = false
        }).catch(() => {
          // on cancel
        });
      }
    },
    // 跳转
    linkComponents () {

    },
    //调用相册&相机
    fileClick () {
      document.getElementById("upload_file").click()
    },

  }
}
</script>

<style lang="scss" scoped>
.menus {
  height: 100vh;
  background: #f4f6f7;
  /deep/ .van-cell {
    font-size: 16px;
  }
  /deep/ .van-cell__value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  /deep/ .van-popup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__list {
    &__icon {
      font-size: 20px;
      line-height: 24px;
      margin-right: 5px;
      height: 24px;
    }
  }
}
</style>